export * from './comunicacion-detail.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/comunicaciones/comunicacion-detail/index.ts